<p-dialog
  draggable="false"
  styleClass="transcript-upload-dialog"
  [header]="titleKey() | translate"
  [modal]="true"
  [closable]="true"
  [visible]="visible()"
  (visibleChange)="visible.set($event); !$event && stagedFiles.set([])"
>
  <app-file-uploader
    [uploadListReview]="true"
    [hideScanning]="true"
    (filesStaged)="onFilesStaged($event)"
  ></app-file-uploader>

  @if (stagedFiles().length > 0) {
    <ul
      class="staged-files"
      [attr.aria-label]="'ITP.selectTranscripts' | translate"
    >
      @for (file of stagedFiles(); track $index) {
        <li class="staged-file">
          <i
            class="fa-solid fa-check staged-file-check"
            aria-hidden="true"
          ></i>
          <span class="staged-file-name">{{ file.name }}</span>
          <p-button
            class="dap-remove-staged-file-btn"
            icon="fa-solid fa-trash"
            severity="danger"
            variant="text"
            [attr.aria-label]="'ITP.removeFile' | translate"
            [ariaLabel]="'ITP.removeFile' | translate"
            (onClick)="removeFile($index)"
          ></p-button>
        </li>
      }
    </ul>
  }

  <ng-template pTemplate="footer">
    <p-button
      class="dap-close-upload-dialog-btn"
      variant="text"
      [label]="'close' | translate"
      (onClick)="close()"
    ></p-button>
    <p-button
      class="dap-confirm-upload-btn"
      [label]="'ITP.upload' | translate"
      [disabled]="stagedFiles().length === 0"
      (onClick)="onUpload()"
    ></p-button>
  </ng-template>
</p-dialog>
